export default __webpack_public_path__ + "static/media/emptylogin.50fd9991.png";